// extracted by mini-css-extract-plugin
export default {"wrapper":"j1-z","play":"k1-z"};